import { type OnboardingFlowType } from '#app/components/GetStartedPage/types.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { shouldRedirectToOnboarding } from '#app/utilities/shouldRedirectToOnboarding.js';
import { useCallback } from 'react';

export const useShouldUserOnboard = (): {
  shouldUserOnboard: (onboardingFlowType?: OnboardingFlowType) => boolean;
} => {
  const currentUser = useCurrentUser();

  const shouldUserOnboard = useCallback(
    (onboardingFlowType?: OnboardingFlowType) => {
      if (!currentUser) return false;

      return shouldRedirectToOnboarding(
        currentUser.userGroups,
        onboardingFlowType,
      );
    },
    [currentUser],
  );

  return { shouldUserOnboard };
};
